import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import FormBuilder from '../../../../../../shared/components/form-builder/form-builder';
import { TcComponentInformation } from '../../../../tc-models/tc-req-dto/input-tc-component-details.res_dto';
import { TCAppConfig } from '../../../../../../shared/app-configs/tc-app-configs';
import { useApi } from '../../../../../../shared/hooks/useApi';
import { Option } from '../../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto';
import { useParams } from 'react-router-dom';
import { Utills } from '../../../../../../shared/app-configs/utilit';

interface ProductInfoProps {
  formRef: any;
  componentData: TcComponentInformation;
  setComponentData: React.Dispatch<React.SetStateAction<TcComponentInformation>>;
}

const ProductInfo: React.FC<ProductInfoProps> = ({ formRef, componentData, setComponentData }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const {TE_ID}=useParams();
  const {executeGet}=useApi()
  const [productNoiOptions,setProductNoOptions] = useState<Option[]>([])
  const toggleDrawer = () => {
    if (drawerOpen) resetForm();
    setDrawerOpen((prev) => !prev);
  };

  const resetForm = () => {
    setComponentData(componentData);
  };
  const loadFormData = async () => {
    try {
      const response = await executeGet(TCAppConfig.GET_INPUT_TC_PRODUCTDETAILS_INFO, { tcId: TE_ID });
      const result =
  response?.data.response?.map((detail: { inputTcProductNo?: string }) => ({
    value: detail.inputTcProductNo ?? "",
    label: detail.inputTcProductNo ?? "",
  })) || [];
      setProductNoOptions(result);

    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  useEffect(()=>{
    TE_ID && loadFormData();
  },[])
  const formConfig = {
     pageName:"input-tc-component-details",
    initialValues: componentData,
    validationSchema: Yup.object().shape({
      inputTcProductNo: Yup.string().required("Please pick Input TC Product No."),
      inputTcProductComponentNo: Yup.string().nullable(),
      inputTcComponentDetail: Yup.string().nullable(),
      inputTcComponentInfoTrimsExcluded: Yup.string().nullable(),
      inputTcComponentInfoAssociatedTc: Yup.string().nullable(),
      inputTcComponentInfoFiberLength: Yup.string().nullable(),
      inputTcComponentInfoYarnCount: Yup.string().nullable(),
      inputTcComponentInfoFabricWeightAndConstruct: Yup.string().nullable(),
      inputTcComponentInfoFabricWeightOfFinishedProduct: Yup.string().nullable(),
      inputTcComponentNetShippingWeight: Yup.string()
      .test(
        'is-exactly-two-decimal-places',
        'Number must be a valid decimal number with upto 2 decimal places.',
        (value: string | undefined) => {
          if (!value) return true; // Allow empty values for required validation to handle
          return /^(0|[1-9]\d*|0\.\d{1,2}|[1-9]\d*\.\d{1,2})$/.test(value); // Match exactly two decimal places
        }
      ),
      inputTcComponentSupplementaryWeight: Yup.string()
      .test(
        'is-exactly-two-decimal-places',
        'Number must be a valid decimal number with upto 2 decimal places.',
        (value: string | undefined) => {
          if (!value) return true; // Allow empty values for required validation to handle
          return /^(0|[1-9]\d*|0\.\d{1,2}|[1-9]\d*\.\d{1,2})$/.test(value); // Match exactly two decimal places
        }
      ),
      inputTcComponentInfoAdditional: Yup.string().nullable(),
    }),
    sections: [
      {
        title: 'Input Product Component Details',
        fields: [
          {
            label: 'Input Product No.',
            name: 'inputTcProductNo',
            type: 'select',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            enableSearch:true,
            props: {options:productNoiOptions, placeholder: 'Enter Input TC Product No.' },
          },
          {
            label: 'Product Component No.',//'Input Product Component No.',
            name: 'inputTcProductComponentNo',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            props: { placeholder: 'Enter Product Component No.' },
          },
          {
            label: 'Component Detail',//renamed to match tbl hdr
            name: 'inputTcComponentDetail',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            props: {
              placeholder: 'Enter Component Detail',
            },
          },
          {
            label: 'Component Info Trims Excluded',//label: 'Input Component Info Trims',renamed to match tbl hdr
            name: 'inputTcComponentInfoTrimsExcluded',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            props: { placeholder: 'Enter Trims Excluded Info' },
          },
          {
            label: 'Component Info Associated TC',//renamed to match tbl hdr label: 'Input Component Info Associated TC',
            name: 'inputTcComponentInfoAssociatedTc',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6},
            required: false,
            props: { placeholder: 'Enter Associated TC Info' },
          },
          {
            label: 'Component Info Fiber Length',//renamed to match tbl hdr label
            name: 'inputTcComponentInfoFiberLength',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6},
            required: false,
            props: { placeholder: 'Enter Fiber Length' },
          },
          {
            label: 'Product Component Info Yarn Count',//renamed to match tbl hdr
            name: 'inputTcComponentInfoYarnCount',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6},
            required: false,
            props: { placeholder: 'Enter Yarn Count' },
          },
          {
            label: 'Component Info Fabric Weight and Construct (kg)',//renamed to match tbl hdr label
            name: 'inputTcComponentInfoFabricWeightAndConstruct',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            props: { placeholder: 'Enter Fabric Weight and Construct' },
          },
          {
            label: 'Component Info Fabric Weight of Finished Product (kg)',//renamed to match tbl hdr label
            name: 'inputTcComponentInfoFabricWeightOfFinishedProduct',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            props: { placeholder: 'Enter Fabric Weight of Finished Product' },
          },
          {
            label: 'Component Net Shipping Weight (kg)',//renamed to match tbl hdr label
            name: 'inputTcComponentNetShippingWeight',
            type: 'number',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            props: { placeholder: 'Enter Net Shipping Weight', type: 'number' },
          },
          {
            label: 'Component Supplementary Weight (kg)',//renamed to match tbl hdr label
            name: 'inputTcComponentSupplementaryWeight',
            type: 'number',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            props: { placeholder: 'Enter Supplementary Weight', type: 'number' },
          },
          {
            label: 'Input Component Info Additional',
            name: 'inputTcComponentInfoAdditional',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            props: { placeholder: 'Enter Additional Info' },
          },
        ],
      },
    ],
    handleSubmit: (values: any) => {
      Utills.cl('Form Submitted:', values);
      setComponentData(values);
      toggleDrawer();
    },
  };

  return (
    <>
      <FormBuilder formConfig={formConfig} onSubmit={formConfig.handleSubmit} formRef={formRef} />
    </>
  );
};

export default ProductInfo;